import { MetricUId } from "../../Metrics/constants"
import getChartConfigTemplate from "../Templates/StackedBarChart/utils";
import { mergeProps } from "../../../generic/Utils/mergeProps";

const metricColorMap = {
  [MetricUId.MENTEES_WHO_SENT_REQUEST_BUT_NEVER_CONNECTED]: "#0969DA",
  [MetricUId.MENTEES_WHO_HAVENT_SENT_MENTORING_REQUEST_AND_NEVER_CONNECTED]: "#FA5F5F"
}

const getChartConfig = function(props = {}) {
  const mergedProps = mergeProps(props, {
    seriesMetricsUids: [MetricUId.MENTEES_WHO_SENT_REQUEST_BUT_NEVER_CONNECTED, MetricUId.MENTEES_WHO_HAVENT_SENT_MENTORING_REQUEST_AND_NEVER_CONNECTED],
    metricColorMap: metricColorMap
  });

  return getChartConfigTemplate(mergedProps);
};

export default getChartConfig;